module.exports = __webpack_public_path__ + "static/media/ivan2.d65aebfb.JPG";